// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import {
  CommercePlanV1,
  CommerceProActiveRestoreV1,
  IdentityRegistrationV1,
  IdentitySignInV1,
  PlatformConfigurationV1,
  PlatformCrashV1,
  PlatformRuntimeV1,
  PlatformVendorV1,
  ServiceHttpV1,
  TestTestErrorV1,
  UiComponentV1,
  UiLaunchV1,
  UiLocalizationV1,
  UiRouteV1,
  TestTestEventV2,
  ApplicationHeartbeatV1,
  ApplicationLaunchStateChangeV1,
  PerformanceMarkV1,
  PerformanceMeasureV1,
  RequestMeasureV1
} from './';

/**
 * A collection of all the events in the SDK grouped by its kind, group, name and version.
 * @internal
 */
/* eslint-disable-next-line @rushstack/typedef-var */
export const _EventHierarchy = {
  Errors: {
    Commerce: {
      Plan: {
        v1: new CommercePlanV1()
      },
      Proactiverestore: {
        v1: new CommerceProActiveRestoreV1()
      }
    },
    Identity: {
      Registration: {
        v1: new IdentityRegistrationV1()
      },
      Signin: {
        v1: new IdentitySignInV1()
      }
    },
    Platform: {
      Configuration: {
        v1: new PlatformConfigurationV1()
      },
      Crash: {
        v1: new PlatformCrashV1()
      },
      Runtime: {
        v1: new PlatformRuntimeV1()
      },
      Vendor: {
        v1: new PlatformVendorV1()
      }
    },
    Service: {
      Http: {
        v1: new ServiceHttpV1()
      }
    },
    Test: {
      Testerror: {
        v1: new TestTestErrorV1()
      }
    },
    Ui: {
      Component: {
        v1: new UiComponentV1()
      },
      Launch: {
        v1: new UiLaunchV1()
      },
      Localization: {
        v1: new UiLocalizationV1()
      },
      Route: {
        v1: new UiRouteV1()
      }
    }
  },
  Events: {
    Test: {
      Testevent: {
        v2: new TestTestEventV2()
      }
    },
    Application: {
      Heartbeat: {
        v1: new ApplicationHeartbeatV1()
      },
      Launchstatechange: {
        v1: new ApplicationLaunchStateChangeV1()
      }
    },
    Performance: {
      Mark: {
        v1: new PerformanceMarkV1()
      },
      Measure: {
        v1: new PerformanceMeasureV1()
      }
    },
    Request: {
      Measure: {
        v1: new RequestMeasureV1()
      }
    }
  }
};
